export default {
    'diagram2-3a1': {
        'diagram-number': '2.',
        'elements': {
            'one': 'Neither boxers nor epileptics can remember events immediately before a blow or a seizure',
            'two': 'However, TMAO stops working below 7,000 meters, presumably dooming any fish swimming deeper to “drown”',
            'three': 'Suggests people need time to consolidate short-term memories before entering them into long-term storage',
        },
        'submit-title': 'submit',
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram2/i18n/en.js